import { Loader } from 'semantic-ui-react';

export const FullScreenLoader = ({ text }: { text?: string }) => (
  <div data-testid="full-screen-loader">
    <Loader active size="big">
      {text ?? 'Loading...'}
    </Loader>
  </div>
);
